const strict = true;

const state = {
  info: {
    active: false,
    title: "",
    text: "",
    buttons: []
  }
};

const getters = {
  info: state => state.info
};

const mutations = {
  reset(state) {
    state.info = {
      active: false,
      title: "",
      text: "",
      buttons: []
    };
  },
  openDialog(state, info) {
    state.info = {
      active: true,
      ...info
    };
  }
};

const actions = {};

export default {
  namespaced: true,
  strict,
  state,
  getters,
  mutations,
  actions
};
